import { Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatterDispatch } from '@state/matter';
import { fade, openClose } from '@core/animations/animations';
import { SelectedMatter } from 'src/app/shared/state/matter/matter.selectors';
import { select } from '@ngxs/store';

@UntilDestroy()
@Component({
	selector: 'app-rental-equipment',
	templateUrl: './rental-equipment.component.html',
	animations: [fade(), openClose(300)],
	standalone: false,
})
export class RentalEquipmentComponent implements OnInit {
	matter_ = select(SelectedMatter.getSelected);
	rentalEquipment: string;
	rentalEquipmentDescription: string;
	checkboxOptions = [
		{ label: 'Yes', value: 'yes' },
		{ label: 'No', value: 'no' },
	];

	constructor(private matterDispatch: MatterDispatch) {}

	ngOnInit(): void {
		if (this.matter_()) {
			if (this.matter_()?.propertyDetails?.rentalEquipment !== undefined) {
				this.rentalEquipment = this.matter_()?.propertyDetails?.rentalEquipment
					? 'yes'
					: 'no';
			}

			this.rentalEquipmentDescription =
				this.matter_()?.propertyDetails?.rentalEquipmentDescription;
		}
	}

	setRentalEquipment(event: string): void {
		if (!this.matter_()?.id) {
			return;
		}

		this.rentalEquipment = event;
		const model = event === 'yes';
		this.matterDispatch.SetRentalEquipment(this.matter_().id, model);

		if (!model) {
			this.setRentalEquipmentDescription('');
		}
	}

	setRentalEquipmentDescription(event: string): void {
		if (!this.matter_()?.id) {
			return;
		}

		this.rentalEquipmentDescription = event;
		this.matterDispatch.SetRentalEquipmentDescription(this.matter_().id, event);
	}
}
